import axios from 'axios'
import qs from 'qs'
import { $go_wx_login_url } from "@/util/wx_util"

axios.defaults.timeout = 30000

// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}

// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true

// HTTP request拦截
axios.interceptors.request.use(req => {
  var v4_token_mall = sessionStorage.getItem("budo.v4_token_mall")
  req.headers['Authorization'] = 'Bearer ' + v4_token_mall

  if (req.method === 'get') {
    req.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }

  return req
}, error => {
  return Promise.reject(error)
})

// HTTP response拦截
axios.interceptors.response.use(res => {
  const status = Number(res.status) || 200
  if (status === 401 || res?.data?.code == -3) {
    budo_log.info('#38 err 401 le', location, res)

    var redirectUrl = location.pathname + location.search + location.hash
    $go_wx_login_url(redirectUrl)

    return Promise.reject(new Error("Err user no login"))
  }

  return res.data
}, error => {
  return Promise.reject(new Error(error))
})

export default axios;
